import { ReactNode } from 'react';
import usePermissionsContext from './use-permissions-context';

export function useRenderByPermission() {
  const { list: listPermissions, hasIndividualPermissions } =
    usePermissionsContext();

  // Usado apenas para itens ADITIVOS: só aparece se o usuário tiver
  // permissões individuais atribuídas E a permissão estiver na lista.
  // Nunca remove nem altera itens que o papel já concede.
  const renderByPermission = (
    permission: string[],
    component: () => ReactNode,
  ) => {
    if (!hasIndividualPermissions) return null;
    return listPermissions.some((p) => permission.includes(p)) && component();
  };

  return {
    renderByPermission,
  };
}
